import React from 'react';

const TimeSlotPicker = ({ availableSlots, selectedSlot, onSlotSelect }) => {
    return (
        <div className="my-4">
            <h3 className="text-xl font-semibold mb-2">Select a Time Slot</h3>
            {availableSlots.length === 0 ? (
                <p className="text-gray-600">No available slots for this date.</p>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                    {availableSlots.map((slot, index) => (
                        <button
                            key={index}
                            className={`p-3 rounded-lg border ${
                                selectedSlot && selectedSlot.start_time === slot.start_time
                                    ? 'bg-blue-500 text-white border-blue-500'
                                    : 'bg-gray-200 text-gray-800 hover:bg-blue-100 border-gray-300'
                            }`}
                            onClick={() => onSlotSelect(slot)}
                        >
                            {new Date(slot.start_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} -
                            {new Date(slot.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TimeSlotPicker;